import React from "react";
import { createRoot } from "react-dom/client";
import { StoreProvider } from "../app/storeProvider";
import AllCompetitions from "@/app/(general-header)/prizes/house/allCompetitions";
import Modal from "@/app/components/Modal/modal";
import { publishModalVisibility } from "@/app/redux/features/modal/modalSlice";
import { useAppDispatch, useAppSelector } from "@/app/redux/hooks";

function ExploreOurCompetitionsRoot() {
  const dispatch = useAppDispatch();
  const buyYourTicketsModalData = useAppSelector(state => state.modal.data);
  const isBuyTicketModalVisible = useAppSelector(state => state.modal.isOpen);

  return (
    <>
      <AllCompetitions />

      <Modal
        isOpen={isBuyTicketModalVisible}
        title=""
        closeModal={(event: any) => {
          event.stopPropagation?.();
          dispatch(publishModalVisibility({ isOpen: false }));
        }}
        modalClassNames={`md:rounded-2xl xs:absolute xs:bottom-0 xs:w-full xs:rounded-b-none xs:rounded-t-2xl z-10 !max-h-none ${
          isBuyTicketModalVisible ? "!px-4 pt-12 pb-8 lg:!px-8 lg:!pb-10 lg:!pt-12" : ""
        }`}
        body={buyYourTicketsModalData}
      />
    </>
  );
}

const el = document.getElementById("explore-our-competitions");
if (!el) throw new Error("Missing #explore-our-competitions");

createRoot(el).render(
  <StoreProvider>
    <ExploreOurCompetitionsRoot />
  </StoreProvider>
);
